/* eslint-disable @typescript-eslint/naming-convention */
export enum deliverySchedulingTypesEnum {
    immediate,
    future,
    recurring
}
